
// import axios from "axios";
// import { djangoApi } from "./auth";
 
// // Legacy mock backend (json-server). Only the pages that have NOT been
// // connected to Django yet still use this. It shrinks every phase.
// const baseURL = process.env.REACT_APP_API_URL || "http://localhost:5000";
// const api = axios.create({ baseURL });
 
// /* ================================================================== */
// /*  CONNECTED TO DJANGO  (/api/admin/...)                              */
// /* ================================================================== */
 
// /** Keep only the listed keys and tidy up empty form values. */
// const pick = (obj, keys) =>
//   keys.reduce((out, k) => {
//     if (obj[k] !== undefined) out[k] = obj[k];
//     return out;
//   }, {});
// const num = (v) => (v === "" || v === null || v === undefined ? v : Number(v));
// const idOrNull = (v) => (v === "" || v === undefined || v === null ? null : Number(v));
 
// /* ---------------- Courses ---------------- */
// const courseBody = (p) => pick(p, ["name", "description", "active"]);
// export const getAdminCourses = () => djangoApi.get("/api/admin/courses/");
// export const addCourse = (payload) => djangoApi.post("/api/admin/courses/", courseBody(payload));
// export const updateCourse = (id, payload) => djangoApi.patch(`/api/admin/courses/${id}/`, courseBody(payload));
// export const deleteCourse = (id) => djangoApi.delete(`/api/admin/courses/${id}/`);
 
// /* ---------------- Exams ---------------- */
// const examBody = (p) => {
//   const body = pick(p, ["name", "program", "status", "proctoringEnabled"]);
//   if ("courseId" in p) body.courseId = idOrNull(p.courseId);
//   if ("fee" in p) body.fee = num(p.fee);
//   if ("resultDelayHours" in p) body.resultDelayHours = num(p.resultDelayHours);
//   return body;
// };
// export const getAdminExams = () => djangoApi.get("/api/admin/exams/");
// export const addExam = (payload) => djangoApi.post("/api/admin/exams/", examBody(payload));
// export const updateExam = (id, payload) => djangoApi.patch(`/api/admin/exams/${id}/`, examBody(payload));
// export const deleteExam = (id) => djangoApi.delete(`/api/admin/exams/${id}/`);
 
// /* ---------------- Sections ---------------- */
// const sectionBody = (p) => {
//   const body = pick(p, ["name", "type"]);
//   if ("examId" in p) body.examId = Number(p.examId);
//   if ("questions" in p) body.questions = num(p.questions);
//   if ("marks" in p && p.marks !== "") body.marks = num(p.marks);
//   if ("durationMinutes" in p) body.durationMinutes = num(p.durationMinutes);
//   return body;
// };
// export const getSections = (examId) =>
//   djangoApi.get("/api/admin/sections/", { params: examId ? { exam: examId } : {} });
// export const addSection = (payload) => djangoApi.post("/api/admin/sections/", sectionBody(payload));
// export const updateSection = (id, payload) => djangoApi.patch(`/api/admin/sections/${id}/`, sectionBody(payload));
// export const deleteSection = (id) => djangoApi.delete(`/api/admin/sections/${id}/`);
 
// /* ---------------- Schedules ---------------- */
// const scheduleBody = (p) => {
//   const body = pick(p, ["date", "startTime", "endTime", "status"]);
//   if ("examId" in p) body.examId = Number(p.examId);
//   if ("capacity" in p) body.capacity = num(p.capacity);
//   return body;
// };
// export const getSchedules = (examId) =>
//   djangoApi.get("/api/admin/schedules/", { params: examId ? { exam: examId } : {} });
// export const addSchedule = (payload) => djangoApi.post("/api/admin/schedules/", scheduleBody(payload));
// export const updateSchedule = (id, payload) => djangoApi.patch(`/api/admin/schedules/${id}/`, scheduleBody(payload));
// export const deleteSchedule = (id) => djangoApi.delete(`/api/admin/schedules/${id}/`);
 
// /* ================================================================== */
// /*  STILL ON THE MOCK SERVER (next phases)                             */
// /* ================================================================== */
 
// export const getStudents = () =>
//   djangoApi.get("/api/admin/students/");
// export const getAdminPayments = () =>
//   djangoApi.get("/api/admin/payments/");

 
// /* Student name helpers (tolerant of different field names) */
// export const getStudentId = (rec) => {
//   if (!rec) return "";
//   const ref =
//     rec.studentId ??
//     rec.userId ??
//     rec.student_id ??
//     rec.user_id ??
//     rec.studentID ??
//     rec.student ??
//     rec.user ??
//     "";
//   if (ref && typeof ref === "object") return ref.id ?? ref.email ?? "";
//   return ref;
// };
 
// export const getStudentDisplayName = (student) => {
//   if (!student) return "";
//   const joined = [student.firstName, student.lastName].filter(Boolean).join(" ");
//   return student.fullName || student.name || joined || student.username || student.email || "";
// };
 
// export const resolveStudentName = (students, rec) => {
//   if (!rec) return "—";
//   const ref = String(getStudentId(rec) ?? "").trim().toLowerCase();
 
//   const byRef = ref
//     ? students.find((s) =>
//         [s.id, s.userId, s.email, s.mobile]
//           .filter((v) => v !== undefined && v !== null)
//           .map((v) => String(v).trim().toLowerCase())
//           .includes(ref)
//       )
//     : undefined;
 
//   const byRecord =
//     byRef ||
//     students.find(
//       (s) =>
//         (rec.email && s.email && String(rec.email).toLowerCase() === String(s.email).toLowerCase()) ||
//         (rec.studentEmail && s.email && String(rec.studentEmail).toLowerCase() === String(s.email).toLowerCase()) ||
//         (rec.mobile && s.mobile && String(rec.mobile) === String(s.mobile)) ||
//         (rec.studentName && s.fullName && String(rec.studentName).toLowerCase() === String(s.fullName).toLowerCase())
//     );
 
//   return getStudentDisplayName(byRecord) || rec.studentName || rec.fullName || rec.name || "—";
// };
// export const describeStudentRef = (rec) => {
//   const ref = getStudentId(rec);
//   if (ref !== "" && ref != null) return String(ref);
//   const key = Object.keys(rec || {}).find((k) => /student|user|candidate|email|mobile/i.test(k));
//   return key ? `${key}=${String(rec[key])}` : "no student field";
// };
 
// /* Students */


// export const getStudent = (id) =>
//   djangoApi.get(`/api/admin/students/${id}/`);

// export const addStudent = (payload) =>
//   djangoApi.post("/api/admin/students/", payload);

// export const updateStudent = (id, payload) =>
//   djangoApi.patch(`/api/admin/students/${id}/`, payload);

// export const deleteStudent = (id) =>
//   djangoApi.delete(`/api/admin/students/${id}/`);
// /* Questions */
// /* Questions — Django */

// export const getQuestions = (params = {}) =>
//   djangoApi.get("/api/admin/questions/", {
//     params,
//   });

// export const getQuestion = (id) =>
//   djangoApi.get(`/api/admin/questions/${id}/`);

// export const addQuestion = (payload) =>
//   djangoApi.post("/api/admin/questions/", payload);

// export const updateQuestion = (id, payload) =>
//   djangoApi.patch(`/api/admin/questions/${id}/`, payload);

// export const deleteQuestion = (id) =>
//   djangoApi.delete(`/api/admin/questions/${id}/`);


// /* Question Bank PDF Documents — Django */

// // ============================================================
// // QUESTION BANK - DJANGO ADMIN API
// // ============================================================

// export const getAdminQuestions = (sectionId, params = {}) =>
//   djangoApi.get("/api/admin/questions/", {
//     params: {
//       section: sectionId,
//       ...params,
//     },
//   });

// export const updateAdminQuestion = (id, payload) =>
//   djangoApi.patch(`/api/admin/questions/${id}/`, payload);

// export const deleteAdminQuestion = (id) =>
//   djangoApi.delete(`/api/admin/questions/${id}/`);

// export const bulkDeleteAdminQuestions = (questionIds) =>
//   djangoApi.delete("/api/admin/questions/bulk-delete/", {
//     data: {
//       question_ids: questionIds,
//     },
//   });

// // ============================================================
// // QUESTION BANK PDF DOCUMENTS
// // ============================================================

// export const getQuestionDocuments = (sectionId) =>
//   djangoApi.get("/api/admin/question-documents/", {
//     params: {
//       section: sectionId,
//     },
//   });

// export const deleteQuestionDocument = (id) =>
//   djangoApi.delete(`/api/admin/question-documents/${id}/`);

// // ============================================================
// // QUESTION BANK PDF UPLOAD
// // Uses the existing Django parser/importer
// // ============================================================
// export const updateQuestionDocument = (id, payload) =>
//   djangoApi.patch(`/api/admin/question-documents/${id}/`, payload);
// export const uploadQuestionBankPdf = ({
//   sectionId,
//   title,
//   file,
// }) => {
//   const formData = new FormData();

//   formData.append("section_id", sectionId);

//   if (title) {
//     formData.append("title", title);
//   }

//   formData.append("pdf_file", file);

//   return djangoApi.post(
//     "/api/exams/upload/",
//     formData
//   );
// };/* Registrations */
// /* ---------------- Registrations ---------------- */
// export const getAdminRegistrations = () =>
//   djangoApi.get("/api/admin/registrations/");



// export const updateRegistration = (id, payload) => {
//   const body = {};

//   if ("status" in payload) {
//     body.status = payload.status;
//   }

//   if ("proctoringDisabled" in payload) {
//     body.proctoringDisabled =
//       Boolean(payload.proctoringDisabled);
//   }

//   if ("criteriaAccepted" in payload) {
//     body.criteriaAccepted =
//       Boolean(payload.criteriaAccepted);
//   }

//   return djangoApi.patch(
//     `/api/admin/registrations/${id}/`,
//     body
//   );
// };
 
// /* Results */
// export const getResults = () =>
//   djangoApi.get("/api/admin/results/");

// export const updateResult = (id, payload) =>
//   djangoApi.patch(`/api/admin/results/${id}/`, payload);
 
// /* PDF files */

// /* Settings */
// export const getSettings = () => api.get("/settings");
// export const updateSettings = (payload) => api.patch("/settings", payload);
 
// /* Verifications */
// export const getVerifications = () =>
//   djangoApi.get("/api/admin/verifications/");

// export const updateVerification = (id, payload) =>
//   djangoApi.patch(
//     `/api/admin/verifications/${id}/status/`,
//     payload
//   );
 
// /* Messages */

//  export const getStudentExamAttempts = (studentId) =>
//   djangoApi.get(`/api/admin/students/${studentId}/attempts/`);

// export const sendAdminMessage = (payload) =>
//   djangoApi.post("/api/admin/messages/send/", payload);
// /* Proctoring */
// /* ================================================================== */
// /*  PROCTORING — DJANGO ADMIN API                                     */
// /* ================================================================== */

// const PROCTOR_RETENTION_DAYS = 7;

// export const PROCTOR_RETENTION_MS =
//   PROCTOR_RETENTION_DAYS * 24 * 60 * 60 * 1000;


// /*
//  * Get all proctoring sessions.
//  *
//  * Optional params:
//  *   status=ACTIVE
//  *   student=<student id>
//  *   exam=<exam id>
//  */
// export const getProctorSessions = (params = {}) =>
//   djangoApi.get("/api/admin/proctoring/", {
//     params,
//   });


// /*
//  * Get one proctoring session.
//  */
// export const getProctorSession = (id) =>
//   djangoApi.get(`/api/admin/proctoring/${id}/`);


// /*
//  * Issue an administrative warning.
//  *
//  * The backend stores this as a ProctoringEvent.
//  */
// export const sendProctorWarning = (sessionId, detail) =>
//   djangoApi.post(
//     `/api/admin/proctoring/${sessionId}/warning/`,
//     {
//       detail,
//     }
//   );


// /*
//  * Force-submit the student's examination attempt.
//  *
//  * The backend reuses the existing examination submission
//  * service and submits it as an automatic submission.
//  */
// export const forceSubmitProctoringAttempt = (sessionId) =>
//   djangoApi.post(
//     `/api/admin/proctoring/${sessionId}/force-submit/`
//   );


// /*
//  * Existing proctoring rules.
//  */
// export const normalizeDate = (d) => {
//   if (!d) return "";

//   const m = /^(\d{4}-\d{2}-\d{2})/.exec(
//     String(d)
//   );

//   return m ? m[1] : "";
// };


// export const isExamDateProctoringOff = (
//   exam,
//   date
// ) => {
//   const d = normalizeDate(date);

//   return (
//     !!d &&
//     Array.isArray(exam?.proctoringOffDates) &&
//     exam.proctoringOffDates.includes(d)
//   );
// };


// export const isProctoringRequired = (
//   exam,
//   registration,
//   date
// ) => {
//   if (exam?.proctoringEnabled === false) {
//     return false;
//   }

//   if (registration?.proctoringDisabled) {
//     return false;
//   }

//   if (
//     isExamDateProctoringOff(
//       exam,
//       date || registration?.date
//     )
//   ) {
//     return false;
//   }

//   return true;
// };
 
// /* Payments */
import axios from "axios";
import { djangoApi } from "./auth";

// Legacy API for pages that still use the mock backend.
const baseURL = process.env.REACT_APP_API_URL || "https://mockq.wahylab.com/api";
const api = axios.create({ baseURL });

const pick = (obj = {}, keys = []) =>
  keys.reduce((out, key) => {
    if (obj[key] !== undefined) out[key] = obj[key];
    return out;
  }, {});

const num = (value) =>
  value === "" || value === null || value === undefined
    ? value
    : Number(value);

const idOrNull = (value) =>
  value === "" || value === undefined || value === null
    ? null
    : Number(value);

/* =========================
   COURSES
========================= */

const courseBody = (payload = {}) =>
  pick(payload, ["name", "description", "active"]);

export const getAdminCourses = () =>
  djangoApi.get("/api/admin/courses/");

export const addCourse = (payload) =>
  djangoApi.post("/api/admin/courses/", courseBody(payload));

export const updateCourse = (id, payload) =>
  djangoApi.patch(`/api/admin/courses/${id}/`, courseBody(payload));

export const deleteCourse = (id) =>
  djangoApi.delete(`/api/admin/courses/${id}/`);

export const getAdminPurchases = () => api.get("/purchases");

/* =========================
   EXAMS
========================= */

const examBody = (payload = {}) => {
  const body = pick(payload, [
    "name",
    "program",
    "status",
    "proctoringEnabled",
    "proctoring_enabled",
  ]);

  if ("courseId" in payload) {
    body.courseId = idOrNull(payload.courseId);
  }

  if ("course_id" in payload) {
    body.course_id = idOrNull(payload.course_id);
  }

  if ("fee" in payload) {
    body.fee = num(payload.fee);
  }

  if ("resultDelayHours" in payload) {
    body.resultDelayHours = num(payload.resultDelayHours);
  }

  if ("breakDurationMinutes" in payload) {
    body.breakDurationMinutes = num(payload.breakDurationMinutes);
  }

  if ("break_duration_minutes" in payload) {
    body.break_duration_minutes = num(payload.break_duration_minutes);
  }

  return body;
};

export const getAdminExams = () =>
  djangoApi.get("/api/admin/exams/");

export const addExam = (payload) =>
  djangoApi.post("/api/admin/exams/", examBody(payload));

export const updateExam = (id, payload) =>
  djangoApi.patch(`/api/admin/exams/${id}/`, examBody(payload));

export const deleteExam = (id) =>
  djangoApi.delete(`/api/admin/exams/${id}/`);

/* =========================
   EXAM SECTIONS
========================= */

const sectionBody = (payload = {}) => {
  const body = pick(payload, ["name", "type"]);

  if ("examId" in payload) {
    body.examId = idOrNull(payload.examId);
  }

  if ("exam_id" in payload) {
    body.exam_id = idOrNull(payload.exam_id);
  }

  if ("questions" in payload) {
    body.questions = num(payload.questions);
  }

  if ("marks" in payload && payload.marks !== "") {
    body.marks = num(payload.marks);
  }

  if ("durationMinutes" in payload) {
    body.durationMinutes = num(payload.durationMinutes);
  }

  if ("duration_minutes" in payload) {
    body.duration_minutes = num(payload.duration_minutes);
  }

  if ("sectionOrder" in payload) {
    body.sectionOrder = num(payload.sectionOrder);
  }

  if ("section_order" in payload) {
    body.section_order = num(payload.section_order);
  }

  if ("qualificationType" in payload) {
    body.qualificationType = payload.qualificationType || null;
  }

  if ("qualification_type" in payload) {
    body.qualification_type = payload.qualification_type || null;
  }

  if ("qualificationValue" in payload) {
    body.qualificationValue =
      payload.qualificationValue === "" ||
      payload.qualificationValue === null
        ? null
        : Number(payload.qualificationValue);
  }

  if ("qualification_value" in payload) {
    body.qualification_value =
      payload.qualification_value === "" ||
      payload.qualification_value === null
        ? null
        : Number(payload.qualification_value);
  }

  if ("isActive" in payload) {
    body.isActive = Boolean(payload.isActive);
  }

  if ("is_active" in payload) {
    body.is_active = Boolean(payload.is_active);
  }

  return body;
};

export const getSections = (examId) => {
  const params = {};

  if (examId !== undefined && examId !== null && examId !== "") {
    params.exam = examId;
  }

  return djangoApi.get("/api/admin/sections/", { params });
};

export const addSection = (payload) =>
  djangoApi.post("/api/admin/sections/", sectionBody(payload));

export const updateSection = (id, payload) =>
  djangoApi.patch(`/api/admin/sections/${id}/`, sectionBody(payload));

export const deleteSection = (id) =>
  djangoApi.delete(`/api/admin/sections/${id}/`);

/* =========================
   SCHEDULES
========================= */

const scheduleBody = (payload = {}) => {
  const body = pick(payload, [
    "date",
    "startTime",
    "endTime",
    "status",
  ]);

  if ("examId" in payload) {
    body.examId = num(payload.examId);
  }

  if ("capacity" in payload) {
    body.capacity = num(payload.capacity);
  }

  return body;
};

export const getSchedules = (examId) =>
  djangoApi.get("/api/admin/schedules/", {
    params: examId ? { exam: examId } : {},
  });

export const addSchedule = (payload) =>
  djangoApi.post("/api/admin/schedules/", scheduleBody(payload));

export const updateSchedule = (id, payload) =>
  djangoApi.patch(`/api/admin/schedules/${id}/`, scheduleBody(payload));

export const deleteSchedule = (id) =>
  djangoApi.delete(`/api/admin/schedules/${id}/`);

/* =========================
   STUDENTS
========================= */

export const getStudents = () =>
  djangoApi.get("/api/admin/students/");

export const getStudent = (id) =>
  djangoApi.get(`/api/admin/students/${id}/`);

export const addStudent = (payload) =>
  djangoApi.post("/api/admin/students/", payload);

export const updateStudent = (id, payload) =>
  djangoApi.patch(`/api/admin/students/${id}/`, payload);

export const deleteStudent = (id) =>
  djangoApi.delete(`/api/admin/students/${id}/`);

export const getStudentExamAttempts = (studentId) =>
  djangoApi.get(`/api/admin/students/${studentId}/attempts/`);

/* =========================
   STUDENT NAME HELPERS
========================= */

export const getStudentId = (record) => {
  if (!record) return "";

  const ref =
    record.studentId ??
    record.userId ??
    record.student_id ??
    record.user_id ??
    record.studentID ??
    record.student ??
    record.user ??
    "";

  if (ref && typeof ref === "object") {
    return ref.id ?? ref.email ?? "";
  }

  return ref;
};

export const getStudentDisplayName = (student) => {
  if (!student) return "";

  const joined = [student.firstName, student.lastName]
    .filter(Boolean)
    .join(" ");

  return (
    student.fullName ||
    student.full_name ||
    student.name ||
    joined ||
    student.username ||
    student.email ||
    ""
  );
};

export const resolveStudentName = (students = [], record) => {
  if (!record) return "—";

  const ref = String(getStudentId(record) ?? "")
    .trim()
    .toLowerCase();

  const byRef = ref
    ? students.find((student) =>
        [
          student.id,
          student.userId,
          student.user_id,
          student.email,
          student.mobile,
        ]
          .filter((value) => value !== undefined && value !== null)
          .map((value) => String(value).trim().toLowerCase())
          .includes(ref)
      )
    : undefined;

  const found =
    byRef ||
    students.find(
      (student) =>
        (record.email &&
          student.email &&
          String(record.email).toLowerCase() ===
            String(student.email).toLowerCase()) ||
        (record.studentEmail &&
          student.email &&
          String(record.studentEmail).toLowerCase() ===
            String(student.email).toLowerCase()) ||
        (record.mobile &&
          student.mobile &&
          String(record.mobile) === String(student.mobile)) ||
        (record.studentName &&
          (student.fullName || student.full_name) &&
          String(record.studentName).toLowerCase() ===
            String(student.fullName || student.full_name).toLowerCase())
    );

  return (
    getStudentDisplayName(found) ||
    record.studentName ||
    record.fullName ||
    record.full_name ||
    record.name ||
    "—"
  );
};

export const describeStudentRef = (record) => {
  const ref = getStudentId(record);

  if (ref !== "" && ref != null) {
    return String(ref);
  }

  const key = Object.keys(record || {}).find((name) =>
    /student|user|candidate|email|mobile/i.test(name)
  );

  return key ? `${key}=${String(record[key])}` : "no student field";
};

/* =========================
   QUESTIONS
========================= */

export const getQuestions = (params = {}) =>
  djangoApi.get("/api/admin/questions/", { params });

export const getQuestion = (id) =>
  djangoApi.get(`/api/admin/questions/${id}/`);

export const addQuestion = (payload) =>
  djangoApi.post("/api/admin/questions/", payload);

export const updateQuestion = (id, payload) =>
  djangoApi.patch(`/api/admin/questions/${id}/`, payload);

export const deleteQuestion = (id) =>
  djangoApi.delete(`/api/admin/questions/${id}/`);

/* =========================
   QUESTION BANK
========================= */

export const getAdminQuestions = (sectionId, params = {}) =>
  djangoApi.get("/api/admin/questions/", {
    params: {
      ...(sectionId ? { section: sectionId } : {}),
      ...params,
    },
  });

export const updateAdminQuestion = (id, payload) =>
  djangoApi.patch(`/api/admin/questions/${id}/`, payload);

export const deleteAdminQuestion = (id) =>
  djangoApi.delete(`/api/admin/questions/${id}/`);

// FIX: Django bulk-delete endpoint expects POST with question_ids.
export const bulkDeleteAdminQuestions = (questionIds = []) =>
  djangoApi.delete("/api/admin/questions/bulk-delete/", {
    data: { question_ids: questionIds },
  });

/* =========================
   QUESTION BANK PDF DOCUMENTS
========================= */

// FIX: Backend reads section_id from the query parameters.

export const getQuestionDocuments = (sectionId) =>
  djangoApi.get("/api/admin/question-documents/", {
    params: sectionId ? { section: sectionId } : {},
  });


export const updateQuestionDocument = (id, payload) =>
  djangoApi.patch(`/api/admin/question-documents/${id}/`, payload);

export const deleteQuestionDocument = (id) =>
  djangoApi.delete(`/api/admin/question-documents/${id}/`);

/* =========================
   QUESTION BANK PDF UPLOAD
========================= */

export const uploadQuestionBankPdf = ({
  sectionId,
  title,
  file,
  files = [],
}) => {
  const formData = new FormData();

  formData.append("section_id", String(sectionId));

  if (title) {
    formData.append("title", title);
  }

  const uploadFiles =
    files.length > 0
      ? files
      : file
        ? [file]
        : [];

  uploadFiles.forEach((item) => {
    formData.append("pdf_files", item);
  });

  if (uploadFiles.length === 1) {
    formData.append("pdf_file", uploadFiles[0]);
  }

  return djangoApi.post("/api/exams/upload/", formData);
};

/* =========================
   REGISTRATIONS
========================= */

export const getAdminRegistrations = () =>
  djangoApi.get("/api/admin/registrations/");

export const updateRegistration = (id, payload = {}) => {
  const body = {};

  if ("status" in payload) {
    body.status = payload.status;
  }

  if ("proctoringDisabled" in payload) {
    body.proctoringDisabled = Boolean(payload.proctoringDisabled);
  }

  if ("criteriaAccepted" in payload) {
    body.criteriaAccepted = Boolean(payload.criteriaAccepted);
  }

  return djangoApi.patch(`/api/admin/registrations/${id}/`, body);
};

/* =========================
   RESULTS
========================= */

export const getResults = () =>
  djangoApi.get("/api/admin/results/");

export const updateResult = (id, payload) =>
  djangoApi.patch(`/api/admin/results/${id}/`, payload);

/* =========================
   PAYMENTS
========================= */

export const getAdminPayments = () =>
  djangoApi.get("/api/admin/payments/");

export const updatePayment = (id, payload) =>
  djangoApi.patch(`/api/admin/payments/${id}/`, payload);

/* =========================
   SETTINGS
========================= */

export const getSettings = () =>
  api.get("/settings");

export const updateSettings = (payload) =>
  api.patch("/settings", payload);

/* =========================
   VERIFICATIONS
========================= */

export const getVerifications = () =>
  djangoApi.get("/api/admin/verifications/");

export const updateVerification = (id, payload) =>
  djangoApi.patch(`/api/admin/verifications/${id}/status/`, payload);

/* =========================
   MESSAGES
========================= */

export const getAdminMessages = () =>
  djangoApi.get("/api/admin/messages/");

export const sendAdminMessage = (payload) =>
  djangoApi.post("/api/admin/messages/send/", payload);

/* =========================
   PROCTORING
========================= */

const PROCTOR_RETENTION_DAYS = 7;

export const PROCTOR_RETENTION_MS =
  PROCTOR_RETENTION_DAYS * 24 * 60 * 60 * 1000;

export const getProctorSessions = (params = {}) =>
  djangoApi.get("/api/admin/proctoring/", { params });

export const getProctorSession = (id) =>
  djangoApi.get(`/api/admin/proctoring/${id}/`);

export const sendProctorWarning = (sessionId, detail) =>
  djangoApi.post(`/api/admin/proctoring/${sessionId}/warning/`, {
    detail,
  });

export const forceSubmitProctoringAttempt = (sessionId) =>
  djangoApi.post(`/api/admin/proctoring/${sessionId}/force-submit/`);

/* =========================
   PROCTORING RULES
========================= */

export const normalizeDate = (value) => {
  if (!value) return "";

  const match = /^(\d{4}-\d{2}-\d{2})/.exec(String(value));

  return match ? match[1] : "";
};

export const isExamDateProctoringOff = (exam, date) => {
  const normalized = normalizeDate(date);

  return (
    !!normalized &&
    Array.isArray(exam?.proctoringOffDates) &&
    exam.proctoringOffDates.includes(normalized)
  );
};

export const isProctoringRequired = (exam, registration, date) => {
  if (
    exam?.proctoringEnabled === false ||
    exam?.proctoring_enabled === false
  ) {
    return false;
  }

  if (
    registration?.proctoringDisabled ||
    registration?.proctoring_disabled
  ) {
    return false;
  }

  if (isExamDateProctoringOff(exam, date || registration?.date)) {
    return false;
  }

  return true;
};

/* =========================
   DEFAULT EXPORT
========================= */

export default api;

/* =========================
   INSTITUTE ACCOUNT MANAGEMENT
========================= */

export const getInstituteAccounts = () =>
  djangoApi.get("/api/auth/institute/");

export const createInstituteAccount = (payload) =>
  djangoApi.post("/api/auth/institute/", {
    name: payload.name.trim(),
    username: payload.username.trim(),
    email: payload.email.trim(),
  });

export const updateInstituteAccountStatus = (id, isActive) =>
  djangoApi.patch(`/api/auth/institute/${id}/`, {
    is_active: isActive,
  });

export const resetInstituteAccountPassword = (id) =>
  djangoApi.post(`/api/auth/institute/${id}/reset-password/`);

/* =====================================================
   MAIN ADMIN — INSTITUTE PAYMENT APPROVALS
===================================================== */

export const getAdminInstitutePayments = () =>
  djangoApi.get("/api/payments/admin/institute/");

export const reviewAdminInstitutePayment = ({
  paymentId,
  decision,
  adminNote = "",
}) =>
  djangoApi.post("/api/payments/admin/institute/", {
    payment_id: paymentId,
    decision,
    admin_note: adminNote,
  });